module.exports = __webpack_public_path__ + "img/Recycle Icon - charcoal.86b6ff42.svg";